import { AppBar } from '@material-ui/core';
import { styled } from '@material-ui/core/styles';

export const StyledAppBar = styled(AppBar)(() => ({
  backgroundColor: 'white',
  color: 'black',
}));
